export default {
  meta: {
    title: '区域保护',
  },
};
